import { defineStore } from "pinia";
import type { Ref } from "vue";
import { ref } from "vue";

export interface ReplaceList {
    [key: string]: string;
}
export const useLabelStore = defineStore("label", () => {
    const translations: Ref<{ [key: string]: string }> = ref({});

    const setFromJsonString = (json: string) => {
        if (!json) {
            console.error("Unable to set LabelStore from empty json");
            return;
        }

        translations.value = JSON.parse(json.replace(/\n/g, "\\n"));
    };
    const get = (key: string, replace: ReplaceList = {}) => {
        let label: string = translations.value[key] || "";
        for (const [key, value] of Object.entries(replace)) {
            label = label.replaceAll(`{${key}}`, value);
        }

        return label || `No Translation for: ${key}`;
    };

    return {
        translations,
        setFromJsonString,
        get,
    };
});
